<span class="badge badge-style">{{displayMessage}}</span>
